export default {
  methods: {
    handleSaveForm(event) {},

    handleModalClose(event) {},

    open() {
      this.$refs.modal.show();
    },

    cancel() {
      this.close();
    },

    close() {
      this.$refs.modal.hide();
    }
  }
};
